import script from "./TextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./TextArea.vue?vue&type=script&setup=true&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=770dbcd5&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770dbcd5"]])

export default __exports__